// import React, { Fragment, useState, useEffect } from "react";
// import format from "date-fns/format";
// import { connect } from "react-redux";

// import { formatMoney } from "../../../app/common/util/helpers";
// import {
//   getPettyCashTransactions,
//   clearUsersPettyCashRequests,
// } from "../pettyCashActions";
// import classes from "./index.module.css";
// // import Detail from "./details/detail";
// import RequestListItem from "./details";

// const index = ({
//   requests,
//   requestsTotal,
//   getPettyCashTransactions,
//   clearUsersPettyCashRequests,
// }) => {
//   console.log("requests!!!", requests);
//   let [loadingInitial, setLoadingInitial] = useState(true);
//   let [expanded, setExpanded] = useState(false);
//   let [revealMoreClasses, setRevealMoreClasses] = useState(null);
//   let [MemberRowClasses, setMemberRowClasses] = useState(null);
//   let [reason, setReason] = useState(null);
//   let [searchDates, setSearchDates] = useState({start: null, end: null});

//   useEffect(() => {
//     getPettyCashTransactions(null, null).then(() => {
//         setLoadingInitial(false);
//       });
    
//     //move to search form submittion
//     let _date = searchDates.start && searchDates.end ? searchDates : null;
//     let _reason = reason ? reason : null;

//     if (_date && _reason) {

//       getPettyCashTransactions(_date, _reason).then(() => {
//         setLoadingInitial(false);
//       });

//     } else if (_date) {
      
//       getPettyCashTransactions(_date, null).then(() => {
//         setLoadingInitial(false);
//       });

//     } else if (_reason) {

//       getPettyCashTransactions(null, _reason).then(() => {
//         setLoadingInitial(false);
//       });

//     } else {
      
//       getPettyCashTransactions(null, null).then(() => {
//         setLoadingInitial(false);
//       });
//     }
//     //move to search form submittion

//     !expanded
//       ? setRevealMoreClasses([classes.RevealMore])
//       : setRevealMoreClasses([classes.RevealMore, classes.RevealMoreExpanded]);
//     !expanded
//       ? setMemberRowClasses([classes.MemberRow])
//       : setMemberRowClasses([classes.MemberRow, classes.MemberRowExpanded]);

//     return () => {
//       clearUsersPettyCashRequests();
//     };
//   }, [expanded]);

//   let handleClick = () => {
//     setExpanded(!expanded);
//   };

//   return (
//     <Fragment>
//       <div className={classes.MerchantTableWrapper}>
//         <div className={classes.TableWrapper}>
//           {requests && requests.length > 0 ? (
//             <Fragment>
//               <table className={classes.MerchantTable}>
//                 <thead>
//                   <tr>
//                     <th scope="col">Date</th>
//                     <th scope="col">Amount Requested</th>
//                     <th scope="col">Reason</th>
//                     <th scope="col">Approver(s)</th>
//                     <th scope="col">Request Status</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {Object.values(requests).map((request,) => {
//                     return <RequestListItem key={request.id} request={request} />;
//                   })}
//                 </tbody>
//               </table>
//             </Fragment>
//           ) : (
//             <h4>
//               There are no <strong>requests</strong> for the selected period.
//             </h4>
//           )}
//         </div>
//       </div>
//     </Fragment>
//   );
// };

// const mapStateToProps = (state) => ({
//   requests: state.pettyCash.transactions,
//   requestsTotal: 0,
// });


// const actions = {
//   getPettyCashTransactions,
//   clearUsersPettyCashRequests,
// };

// export default connect(mapStateToProps, actions)(index);


import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import moment from "moment";
import { DateRangePicker } from "react-dates";
 
import TextInput from "../../../app/common/form/TransactionsTextInput";
import {
  getPettyCashTransactions,
  clearUsersPettyCashRequests,
} from "../pettyCashActions";
 
import classes from "./index.module.css";
import RequestListItem from "./details";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "../react_dates_overrides.css";
 
const Index = ({
  requests,
  requestsTotal,
  clearUsersPettyCashRequests,
  getPettyCashTransactions,
  handleSubmit,
}) => {
  const [loadingInitial, setLoadingInitial] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const [revealMoreClasses, setRevealMoreClasses] = useState([]);
  const [MemberRowClasses, setMemberRowClasses] = useState([]);
  // let [reason, setReason] = useState(null);
  let [searchDates, setSearchDates] = useState({start: null, end :null});
  const [focusedInput, setFocusedInput] = useState(null);
 
  useEffect(() => {
    getPettyCashTransactions(null).then(() => {
      setLoadingInitial(false);
    });
 
    setRevealMoreClasses(
      expanded
        ? [classes.RevealMore, classes.RevealMoreExpanded]
        : [classes.RevealMore]
    );
 
    setMemberRowClasses(
      expanded
        ? [classes.MemberRow, classes.MemberRowExpanded]
        : [classes.MemberRow]
    );
 
    return () => {
      clearUsersPettyCashRequests();
    };
  }, [expanded]);
 
 const onFormSubmit = async (values) => {
  setLoadingInitial(true);

  let _date = searchDates.start && searchDates.end ? searchDates : null;
  // let _reason = values.reason ? values.reason : null;

  if (_date ) {
    await getPettyCashTransactions(_date);
  }  else {
    await getPettyCashTransactions(null);
  }

  setLoadingInitial(false);
};

 
  const handleClick = () => {
    setExpanded(!expanded);
  };
 
  return (
    <Fragment>
       <header className={classes.TabHeader}>
    <div
  style={{
            display: "flex",
    marginTop:"-60px",
    gap: "10rem",
    alignItems: "center",
    padding: "1rem 0",
  }}
>
  <h4 style={{ margin: 0 }}>Requests</h4>

  <div style={{ display: "flex", gap: "4rem", alignItems: "center" }}>
    {/* Date filter */}
    <div
      style={{
        paddingRight: "3rem",
        // borderRight: "solid 3px #707070",
      }}
    >
      <form onSubmit={handleSubmit(onFormSubmit)}>
        <div className="row" style={{ flexWrap: "nowrap", alignItems: "center" }}>
          <DateRangePicker
            startDate={searchDates.start}
            endDate={searchDates.end}
            onDatesChange={({ startDate, endDate }) => {
              setSearchDates({ start: startDate, end: endDate });
            }}
            focusedInput={focusedInput}
            onFocusChange={setFocusedInput}
            numberOfMonths={1}
            isOutsideRange={(date) => date.isAfter(moment())}
            displayFormat={"YYYY-MM-DD"}
            minimumNights={0}
            small={true}
            readOnly={true}
            startDateId="startDate"
            endDateId="endDate"
          />
           <button
            className={classes.FilterReportBtn}
            style={{ marginLeft: "1rem" }}
            type="submit"
          >
            <svg
              height="20"
              width="20"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <path
                  id="path1"
                  transform="rotate(0,10,10) translate(0,0.00844358491989894) scale(0.562499396503619,0.562499396503619)  "
                  fill="#FFFFFF"
                  d="M12.833076,4.5889625C9.0420458,4.5889625 5.7500408,7.1819653 5.3510525,10.673919 4.9520643,14.364907 7.9450567,17.756886 12.134098,18.055895 16.324117,18.45488 20.015109,15.760895 20.414098,11.970939 20.813148,8.2799505 17.821132,4.8879718 13.631113,4.5889625z M12.733099,5.7343641E-10C13.132088,-2.0158268E-07 13.631113,-2.0158268E-07 14.030102,0.10000526 21.013099,0.6979938 26.100154,6.2849674 25.402154,12.568927 25.103141,14.763922 24.205129,16.758906 22.808151,18.45488L31.288163,27.53283C32.385152,28.629839 32.18514,30.425818 30.889175,31.322817 29.592172,32.320795 27.69617,32.120818 26.599118,31.023808L18.020107,21.746853C16.025104,22.544852 13.830089,22.943867 11.436097,22.743857 4.4530389,22.145869 -0.63395572,16.559901 0.064045019,10.274934 0.76204573,4.3889822 6.3490422,-2.0158268E-07 12.733099,5.7343641E-10z"
                />
              </g>
            </svg>
          </button>
        </div>
      </form>
    </div>

    {/* Reason filter */}
    <div
      style={{
        paddingLeft: "3rem",
        paddingRight: "3rem",
             }}
    >
      {/* <form onSubmit={handleSubmit(onFormSubmit)}>
        <div className="row" style={{ flexWrap: "nowrap", width: "300px", alignItems: "center" }}>
          <Field
            type="text"
            className="form-control"
            style={{ marginBottom: 0 }}
            component={TextInput}
            placeholder="Reason"
            name="reason"
            id="reason"
            autoComplete="off"
          />
           <button
            className={classes.FilterReportBtn}
            style={{ marginLeft: "1rem" }}
            type="submit"
          >
            <svg
              height="20"
              width="20"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <path
                  id="path1"
                  transform="rotate(0,10,10) translate(0,0.00844358491989894) scale(0.562499396503619,0.562499396503619)  "
                  fill="#FFFFFF"
                  d="M12.833076,4.5889625C9.0420458,4.5889625 5.7500408,7.1819653 5.3510525,10.673919 4.9520643,14.364907 7.9450567,17.756886 12.134098,18.055895 16.324117,18.45488 20.015109,15.760895 20.414098,11.970939 20.813148,8.2799505 17.821132,4.8879718 13.631113,4.5889625z M12.733099,5.7343641E-10C13.132088,-2.0158268E-07 13.631113,-2.0158268E-07 14.030102,0.10000526 21.013099,0.6979938 26.100154,6.2849674 25.402154,12.568927 25.103141,14.763922 24.205129,16.758906 22.808151,18.45488L31.288163,27.53283C32.385152,28.629839 32.18514,30.425818 30.889175,31.322817 29.592172,32.320795 27.69617,32.120818 26.599118,31.023808L18.020107,21.746853C16.025104,22.544852 13.830089,22.943867 11.436097,22.743857 4.4530389,22.145869 -0.63395572,16.559901 0.064045019,10.274934 0.76204573,4.3889822 6.3490422,-2.0158268E-07 12.733099,5.7343641E-10z"
                />
              </g>
            </svg>
          </button>
        </div>
      </form> */}
    </div>
  </div>
        </div>
        </header>

      <div className={classes.MerchantTableWrapper}>
        <div className={classes.TableWrapper}>
          {requests && requests.length > 0 ? (
            <table className={classes.MerchantTable}>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Amount Requested</th>
                  <th>Reason</th>
                  <th>Approver(s)</th>
                  <th>Request Status</th>
                </tr>
              </thead>
              <tbody>
                {Object.values(requests).map((request) => (
                  <RequestListItem key={request.id} request={request} />
                ))}
              </tbody>
            </table>
          ) : (
            <h4>
              There are no <strong>requests</strong> for the selected period.
            </h4>
          )}
        </div>
      </div>
 
    </Fragment>
  );
};
 
const mapStateToProps = (state) => ({
  requests: state.pettyCash.transactions,
  requestsTotal: 0,
   initialValues: {
      reason: "",
      start: moment().startOf("day"),
      end: moment().endOf("day"),
    },
    enableReinitialize: true,
});
 
const actions = {
  getPettyCashTransactions,
  clearUsersPettyCashRequests,
};
 
// Wrap with reduxForm, then connect to Redux
export default connect(
  mapStateToProps,
  actions
)(
  reduxForm({
    form: "pettyCashSearchForm",
  })(Index)
);